export const COIN_NAME_TO_COINCAP_API_COIN_NAME_MAP: Record<string, string> = {
  ripple: 'xrp',
};

export const CRYPTO_CHANGES_KEY = 'crypto-changes';
